import {
  CircularProgress as CircularProgressMui5,
  CircularProgressProps as CircularProgressPropsMui5,
} from '@mui/material'

export type CircularProgressProps = CircularProgressPropsMui5

export const CircularProgress = (props: CircularProgressProps) => {
  return <CircularProgressMui5 {...props} />
}
